<script>
  export let result;
  export let quickOrderListProductID;
  export let onChooseSize;
  export let onAddToListChooseSizeLater;
  export let onRemoveProductLinePlaceholder;
  import { stagedRolloutCheck } from "@shared/svelte/Modules/StagedRolloutCheck.svelte";
  import RetailerUserAuthenticationsStore from "@retailer/svelte/stores/RetailerUserAuthenticationsStore";
  import { shouldHideAllDistributorInfo } from "@shared/services/retailer_user_authentication_service";

  const hasRetailerUserAuthRollout = stagedRolloutCheck(
    "marketplace__retailer_user_authentication",
  );

  $: hideAllDistributorInfo =
    hasRetailerUserAuthRollout &&
    result?.product_line?.distributor_info &&
    shouldHideAllDistributorInfo($RetailerUserAuthenticationsStore, [
      result?.product_line?.distributor_info?.distributor_id,
    ]);
</script>

<div
  class="list-builder__result-container media padding--small background-white box-shadow box-shadow--hover margin-bottom--small"
>
  <div class="media-fluid list-builder__result-title">
    <div class="default-subheader--bold">{result.product_line.name}</div>
    {#if result.distributor.name}
      <div class="default-subheader--regular">{result.distributor.name}</div>
    {/if}
  </div>
  <div class="media-fluid align-right">
    {#if !hideAllDistributorInfo}
      <div class="list-builder__result-add-button">
        <button
          class="button button--primary button--smallest margin-bottom--smallest"
          on:click|preventDefault={() => onChooseSize(result.product_line)}
        >
          {result.product_line.distributor_info.is_vintage_product
            ? "Choose Vintage & Size"
            : "Choose Size"}
        </button>
      </div>
    {/if}
    {#if quickOrderListProductID != null}
      <div class="list-builder__result-choose-size-button">
        <span
          role="button"
          on:click|preventDefault={() => onRemoveProductLinePlaceholder(quickOrderListProductID)}
          class="cursor-pointer brand-body--bold color-red"
        >
          Remove placeholder from list
        </span>
      </div>
    {:else}
      <div class="list-builder__result-choose-size-button">
        <span
          role="button"
          on:click|preventDefault={() => onAddToListChooseSizeLater(result.product_line)}
          class="cursor-pointer brand-body--bold"
        >
          Save to List
        </span>
        <span>&nbsp;(choose size later)</span>
      </div>
    {/if}
  </div>
</div>
